import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL: /organizations was the org-info page in admin-nextjs before
// the Settings hub consolidation. Permanent redirect → /settings/info so
// any external bookmark or shared link keeps working.
export const Route = createFileRoute("/_admin/organizations")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/info", replace: true });
  },
});
